(function() {
    'use strict';
    angular.module('Const').constant('FuelLevySpecialInstructionsConst', [
        {
            "carrierId" : "aramex",
            "url" : "https://www.aramex.com.au/terms-and-conditions/fuel-surcharge/"
        },
        {
            "carrierId" : "aramex-international",
            "url" : "https://www.aramex.com/us/en/fuel-surcharge"
        },
        {
            "carrierId" : "as",
            "url" : "https://auspost.com.au/business/shipping/check-postage-costs/fuel-surcharge"
        },
        {
            "carrierId" : "bba-seko",
            "url" : "https://www.sekologistics.com/us/about/resources/seko-fuel-surcharge-rates-2022-usa/"
        },
        {
            "carrierId" : "bba-toll",
            "url" : "https://tgexpress.com.au/fuel-surcharge"
        },
        {
            "carrierId" : "couriers-please",
            "url" : "https://www.couriersplease.com.au/tools/shipping-tools/fuel-surcharge"
        },
        {
            "carrierId" : "dhl",
            "url" : "https://mydhl.express.dhl/au/en/ship/surcharges.html#/fuel_surcharge"
        },
        {
            "carrierId" : "dhl-ecommerce",
            "url" : "https://www.dhl.com/us-en/home/ecommerce-solutions/business-help-center/surcharge-policies.html"
        },
        {
            "carrierId" : "dhl-international",
            "url" : "https://mydhl.express.dhl/au/en/ship/surcharges.html#/fuel_surcharge"
        },
        {
            "carrierId" : "fastway",
            "url" : "https://www.aramex.com.au/terms-and-conditions/fuel-surcharge/"
        },
        {
            "carrierId" : "fastway-colored-label",
            "url" : "https://www.aramex.com.au/terms-and-conditions/fuel-surcharge/"
        },
        {
            "carrierId" : "hunter-express",
            "url" : "https://www.hunterexpress.com.au/finance-related-queries/"
        },
        {
            "carrierId" : "seko",
            "url" : "https://www.sekologistics.com/us/about/resources/seko-fuel-surcharge-rates-2022-usa/"
        },
        {
            "carrierId" : "startrack",
            "url" : "https://startrack.com.au/pricing-updates"
        },
        {
            "carrierId" : "tnt",
            "url" : "https://www.tnt.com/express/en_au/site/how-to/understand-fuel-surcharges.html"
        },
        {
            "carrierId" : "toll",
            "url" : "https://tgexpress.com.au/fuel-surcharge"
        }
    ]);
})();



// WEBPACK FOOTER //
// ./js/consts/fuelLevySpecialInstructionsConst.js